import { clsx } from "clsx";
import { darken, mix, saturate } from "polished";
import { type CSSProperties, type FC, type PropsWithChildren, useMemo } from "react";

import style from "./GradientLabel.module.css";

export interface GradientLabelProps {
  start: CSSProperties["backgroundColor"];
  stop: CSSProperties["backgroundColor"];
  alignment?: "right" | "left"; // default is left
}

const GradientLabel: FC<PropsWithChildren<GradientLabelProps>> = (props) => {
  const borderColor = useMemo(
    () => (props.start && props.stop ? darken(0.15, saturate(0.1, mix(0.5, props.stop, props.start))) : "#a8a29e"),
    [props.start, props.stop],
  );

  const gradientElement = props.start && props.stop && (
    <div
      aria-hidden
      className={clsx(style.mini_gradient)}
      style={{ background: `linear-gradient(to right, ${props.start}, ${props.stop})`, borderColor }}
    />
  );

  return (
    <span className={style.bullet_container} data-testid={"gradient-label"}>
      {props.alignment !== "right" && gradientElement}
      {props.children}
      {props.alignment === "right" && gradientElement}
    </span>
  );
};

export { GradientLabel };
